<ng-template #extracontent>
    <ng-container *ngIf="display">
        <ion-item [ngClass]="{ 'disabled': display.status === 'UN' }">
            <div class="thumb-box" slot="start" uppDataid="ticketextra-image-info">
                <div class="image-box">
                    <upp-image [src]="display.photo || display.avatar"></upp-image>
                </div>
            </div>    
            <div class="info">
                <ion-item>
                    <ion-label>
                        {{display.name || tr('@ticket_extra_noname')}}<br/>
                        <ng-container *ngIf="display.description !== null">
                            <span class="small">{{display.description}}</span>
                        </ng-container>
                        <ng-container *ngIf="display.description === null">
                            <span class="small" *ngIf="display.type === 'TICKETFIXED'">{{tr('@place_extra_type_fixed_per_ticket')}}</span>
                            <span class="small" *ngIf="display.type === 'ITEMFIXED'">{{tr('@place_extra_type_fixed_per_item')}}</span>
                            <span class="small" *ngIf="display.type === 'ITEMPRCNT'">{{tr('@place_extra_type_percent_per_item')}}</span>
                        </ng-container>
                    </ion-label>
                    <ng-container *ngIf="display.chargeinfo">
                        <ion-label color="medium" class="price" style="font-size: 30px;" slot="end">
                            {{display.chargeinfo.int}}<span class="decimal">,{{display.chargeinfo.dec}}</span>{{tr('@currency')}}
                        </ion-label>    
                    </ng-container>              
                </ion-item>
            </div>
        </ion-item>    
    </ng-container>
</ng-template>

<upp-visible-control mode="content">
    <ng-container *ngIf="mode === 'VIEW'">
        <ng-container [ngTemplateOutlet]="extracontent"></ng-container>
    </ng-container>
    <ng-container *ngIf="mode === 'EDIT'">
        <ion-item-sliding *ngIf="display" #slider>
            <ng-container [ngTemplateOutlet]="extracontent"></ng-container>
            <ion-item-options side="end">
                <ion-item-option [hidden]="IsSliding || (display.status === 'UN')" (click)="RemoveExtra($event, slider)">
                    <ion-item class="options" lines="none">
                        <ion-button uppDataid="extrathumb-del-button" mode="md" slot="icon-only" fill="clear" slot="end">
                            <ion-icon color="danger" name="close-circle-outline"></ion-icon>  
                        </ion-button>
                    </ion-item>
                </ion-item-option>
                <ion-item-option [hidden]="IsSliding || (display.status === 'AC')" (click)="IncludeExtra($event, slider)">
                    <ion-item class="options" lines="none">
                        <ion-button uppDataid="extrathumb-add-button" mode="md" slot="icon-only" fill="clear" slot="end">
                            <ion-icon color="primary" name="checkmark-circle-outline"></ion-icon>  
                        </ion-button>
                    </ion-item>
                </ion-item-option>
            </ion-item-options>           
        </ion-item-sliding>    
    </ng-container>
</upp-visible-control>
